const t = (localizationService: any, key: string) =>
  localizationService.toLanguageString(key, 'NOT_FOUND');

export const usernameValidator = (username: any, localizationService: any) => {
  
  if (!username) {
    return t(localizationService, 'login_error.username_required');
  } 
  return "";
};

const RESET_PASSWORD_REGEX = /^((?=.*\d)(?=.*[A-Z])(?=.*\W).{8,20})$/;

export const passwordValidator = (password: any, localizationService: any) => {
  
  if (!password) {
    return t(localizationService, 'login_error.password_required');
  }
  return "";
};

export const resetPasswordValidator = (password: any, localizationService: any) => {
  if (!password) {
    return t(localizationService, 'login_error.password_required');
  } else if (!RESET_PASSWORD_REGEX.test(password)) {
    return t(localizationService, 'login_error.password_min_length');
  }
  return "";
};

export const emailValidator = (email: any, localizationService: any) => {
  if (!email) {
    return t(localizationService, 'login_error.email_required');
  } 
  else if (!new RegExp(/\S+@\S+\.\S+/).test(email)) {
    return t(localizationService, 'login_error.incorrect_email_format');
  }
  return "";
};

export const confirmPasswordValidator = (password: any, confirmPassword: any, localizationService: any) => {
  if (!password) {
    return t(localizationService, 'login_error.confirm_psw_required');
  } else if (password !== confirmPassword) {
    return t(localizationService, 'login_error.passwords_do_not_match');
  }
  return "";
};

export const confirmPasswordValidatorResetPassword = (password: any, form: any, localizationService: any) => {
  if (!password) {
    return t(localizationService, 'login_error.confirm_psw_required');
  } else if (!RESET_PASSWORD_REGEX.test(password)) {
    return t(localizationService, 'login_error.confirm_psw_min_length');
  } else if (password !== form.confirmPassword) {
    return t(localizationService, 'login_error.passwords_do_not_match');
  }
  return "";
};